export default __webpack_public_path__ + "static/Iterative-Development-4f55e5be9cf05a1dabb73fd58db11aa1.webp";